export default class AdminCommon {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT AdminCommon');
		$('#menu-posts-dp_intro_tours .wp-submenu li:nth-child(5)>a').attr('target', '_blank');
	}
}
